import { useState, useEffect, useCallback } from "react";
import CloseIcon from "@mui/icons-material/Close";
import {
  Alert,
  Box,
  Button,
  Card,
  Divider,
  IconButton,
  ListItem,
  ListItemButton,
  ListItemText,
  Modal,
  Radio,
  Skeleton,
  Stack,
  Typography,
  useMediaQuery
} from "@mui/material";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import ErrorIcon from "@mui/icons-material/Error";
import DeleteIcon from "@mui/icons-material/Delete";
import { Postrequestcall } from "../../request/Postrequest";
import {
  DELETE_USERS_RESUMES,
  FETCH_USERS_RESUME,
  SAVE_USERS_JOB_POSTINGS,
  SAVE_USERS_JOB_POSTS_NEW,
  SEND_USERS_RESUME,
  SEND_USERS_RESUME_2
} from "../../constant/Apipath";
import { useSelector } from "react-redux";
import ResumeBuilderModal from "./ResumeBuilderModal";
import { English } from "../../constant/EnglishFallback";
import { useTheme } from "@emotion/react";
import ResumeDetailsModal from "../resume-builder/ResumeDetailsModal";
import ResumeReachedLimitModal from "./ResumeReachedLimitModal";
import DeleteConfirmation from "../common/DeleteConfirmation";

function ResumeList(props) {
  const { from } = props;

  const { multiLanguageData } = useSelector((state) => state?.main);

  const LanguageData = multiLanguageData?.JobPostings || {};
  const {
    TEXT_APPLY_TO = English.JobPostings.TEXT_APPLY_TO,
    TEXT_CHOOSE_RESUME = English.JobPostings.TEXT_CHOOSE_RESUME,
    TEXT_GENERATE_RESUME = English.JobPostings.TEXT_GENERATE_RESUME,
    TEXT_SUBMIT_APPLICATION = English.JobPostings.TEXT_SUBMIT_APPLICATION,
    TEXT_BACK_BUTTON = English.JobPostings.TEXT_BACK_BUTTON,
    TEXT_GENERATE_RESUME_QUICKLY = English.JobPostings?.TEXT_GENERATE_RESUME_QUICKLY ,
    TEXT_A_RESUME_IS_REQUIRED = English.JobPostings?.TEXT_A_RESUME_IS_REQUIRED ||
      "A resume is required to apply.",
    TEXT_MY_RESUMES = English?.JobPostings?.TEXT_MY_RESUMES || "My Resumes"
  } = LanguageData || {};

  const {
    TEXT_MENU_DELETE_BTN = English.ResumeBuilder.TEXT_MENU_DELETE_BTN,
    TEXT_CONFIRM_DELETE = English.ResumeBuilder.TEXT_CONFIRM_DELETE,
    TEXT_DELETE_THIS_RESUME = English.ResumeBuilder.TEXT_DELETE_THIS_RESUME
  } = multiLanguageData?.ResumeBuilder || {};

  const [resumes, setResumes] = useState([]);
  const [selectedResumeIndex, setSelectedResumeIndex] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [openResumeBuilder, setOpenResumeBuilder] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { loginData } = useSelector((state) => state?.main);
  const [resources, setResources] = useState("");
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const [openResumeDetailsModal, setOpenResumeDetailsModal] = useState(false);
  const [selectedResume, setSelectedResume] = useState(null);
  const [openResumeReachedModal, setOpenResumeReachedModal] = useState(false);
  const [showDeleteResumeButton, setShowDeleteResumeButton] = useState(false);
  const [openDeleteConfirmModal, setOpenDeleteConfirmModal] = useState(false);
  const [deleteResId, setDeleteResId] = useState(null);

  const handleCloseResumeDetail = () => {
    setOpenResumeDetailsModal(false);
    setSelectedResume(null);
  };

  const userID = Number(loginData?.userInformation?.UserId || 0);

  const fetchResumes = useCallback(async () => {
    setIsLoading(true);
    try {
      const fetchResumeObj = {
        PageNr: 1,
        NrOfRecPerPage: 20,
        FullSearch: "",
        UserId: Number(loginData?.userInformation?.UserId),
        IncludeRecordNr: true,
        TypeOfObjectReturned: "",
        SearchList: [{ UserId: Number(loginData?.userInformation?.UserId) }]
      };

      const result = await Postrequestcall(
        FETCH_USERS_RESUME,
        fetchResumeObj,
        loginData?.accessToken
      );

      const sortedResumes = result?.data?.data?.sort(
        (a, b) => new Date(b.resumeDate) - new Date(a.resumeDate)
      );

      setResumes(sortedResumes || []);

      const now = new Date();

      const recentIndex = sortedResumes?.findIndex((resume) => {
        const resumeDate = new Date(resume.resumeDate);
        const timeDiff = Math.abs(now.getTime() - resumeDate.getTime());
        return timeDiff <= 60000;
      });

      if (recentIndex !== -1 && sortedResumes[recentIndex]) {
        setSelectedResumeIndex(recentIndex);
        setResources(sortedResumes[recentIndex]?.resumePdf || "");
        setErrorMessage("");
      } else if (sortedResumes.length > 0) {
        setSelectedResumeIndex(0);
        setResources(sortedResumes[0]?.resumePdf || "");
      }
    } catch (error) {
      console.error("fetchResumes-> Error fetching resumes: ", error);
    } finally {
      setIsLoading(false);
    }
  }, [loginData]);

  useEffect(() => {
    if (props.open) fetchResumes();
    return () => {
      setResumes([]);
      setSelectedResumeIndex(null);
      setShowDeleteResumeButton(false);
      setResources("");
    };
  }, [props.open]);

  const handleResumeClick = (index, item) => {
    if (from === "myJobsModal") {
      setSelectedResume(item);
      setOpenResumeDetailsModal(true);
      return;
    }
    if (selectedResumeIndex === index) {
      setSelectedResumeIndex(null);
    } else {
      setSelectedResumeIndex(index);
      setResources(item?.resumePdf);
      setErrorMessage("");
    }
  };

  const handleDelete = async () => {
    setOpenDeleteConfirmModal(false);
    try {
      const deleteData = {
        userId: Number(loginData?.userInformation?.UserId),
        ReturnRecordId: false,
        ReturnRecordError: true,
        DeleteList: [{ Id: deleteResId, ModifiedBy: Number(loginData?.userInformation?.UserId) }]
      };
      await Postrequestcall(DELETE_USERS_RESUMES, deleteData, loginData?.accessToken);
      await fetchResumes();
      setDeleteResId(null);
      setShowDeleteResumeButton(false);
    } catch (error) {
      console.error("handleDelete-> Error deleting resume: ", error);
    }
  };

  const handleDownload = async (resumePdf, title) => {
    try {
      if (!resumePdf) return;

      const fileName = `${title || "resume"}.pdf`;
      let blob;

      const isUrl = resumePdf.startsWith("http://") || resumePdf.startsWith("https://");

      if (isUrl) {
        const response = await fetch(resumePdf);
        if (!response.ok) throw new Error("Failed to fetch PDF");
        blob = await response.blob();
      } else {
        const byteCharacters = atob(resumePdf);
        const byteArray = new Uint8Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteArray[i] = byteCharacters.charCodeAt(i);
        }
        blob = new Blob([byteArray], { type: "application/pdf" });
      }

      const blobUrl = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = blobUrl;
      link.download = fileName;
      document.body.appendChild(link);

      link.click(); // <-- No new tab. Just triggers download.

      document.body.removeChild(link);
      URL.revokeObjectURL(blobUrl);
    } catch (error) {
      console.error("handleDownload-> Error downloading resume: ", error);
    }
  };

  const submitResume = async () => {
    if (selectedResumeIndex === null) {
      setErrorMessage(TEXT_A_RESUME_IS_REQUIRED);
      return;
    }

    setErrorMessage("");
    setIsSubmitting(true);
    try {
      let obj = {
        UserId: userID,
        ReturnRecordId: true,
        ReturnRecordError: true,
        SaveList: [
          {
            Id: 0,
            JobPostId: props?.applyJobData?.id,
            UserId: userID,
            ModifiedBy: userID
          }
        ]
      };
      await Postrequestcall(SAVE_USERS_JOB_POSTS_NEW, obj, loginData?.accessToken);

      const emailObj = {
        UserId: userID,
        Email: props?.applyJobData?.receiveApplicantLink,
        ResumePdf: resources,
        Title: props?.applyJobData?.title || "",
        CompanyId: props?.applyJobData?.companyId || 0
      };
      await Postrequestcall(SEND_USERS_RESUME_2, emailObj, loginData?.accessToken);

      setResources("");
      setResumes([]);
      setSelectedResumeIndex(null);
      props.setOpenResumeListModal(false);
      props.onJobApplied();
    } catch (error) {
      console.error("submitResume-> Error submitting resume: ", error);
    } finally {
      setIsSubmitting(false);
    }
  };

  const onClose = () => {
    props.setOpenResumeListModal(false);
    setSelectedResumeIndex(null);
    setErrorMessage("");
  };

  return (
    <>
      <Modal open={props.open} closeAfterTransition>
        <Box className="user-modal-responsive">
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "space-between"
            }}>
            {from !== "myJobsModal" && (
              <Typography variant="h6" sx={{ fontWeight: "bold" }}>
                {TEXT_APPLY_TO} Job
              </Typography>
            )}
            <IconButton onClick={onClose}>
              <CloseIcon />
            </IconButton>
          </Box>
          {isLoading ? (
            <Stack spacing={1}>
              {Array.from({ length: 5 }).map((_, index) => (
                <Skeleton
                  key={index}
                  variant="rectangular"
                  height={60}
                  sx={{ borderRadius: "10px" }}
                />
              ))}
            </Stack>
          ) : (
            <Stack sx={{ gap: 1 }} >
              <Typography variant="h6">{TEXT_MY_RESUMES}</Typography>
              {from == "myJobsModal" && (
                <Typography variant="subtitle1" sx={{ color: "gray" }}>
                 {TEXT_GENERATE_RESUME_QUICKLY}
                </Typography>
              )}

              {resumes.map((item, index) => (
                <Card
                  key={index.toString()}
                  onClick={() => handleResumeClick(index, item)}
                  className="pagelist-content"
                  sx={{
                    marginTop: "0px",
                    padding: 0,
                    cursor: "pointer",
                    borderRadius: "10px"
                  }}>
                  <ListItem
                    alignItems="flex-start"
                    sx={{ m: 0, p: 0 }}
                    secondaryAction={
                      <>
                        {/* <IconButton
                          onClick={(e) => {
                            e.stopPropagation(); // prevent card click
                            handleDownload(item.resumePdf, item.title);
                          }}>
                          <FileDownloadIcon />
                        </IconButton> */}
                        {from != "myJobsModal" && (
                          <Radio
                            checked={selectedResumeIndex === index}
                            onChange={() => handleResumeClick(index, item)}
                            value={index}
                            inputProps={{ "aria-label": `Resume ${index + 1}` }}
                          />
                        )}
                        {showDeleteResumeButton && (
                          <IconButton
                            onClick={(e) => {
                              e.stopPropagation();
                              setDeleteResId(item.id);
                              setOpenDeleteConfirmModal(true);
                            }}
                            sx={{ color: "error.main" }}>
                            <DeleteIcon />
                          </IconButton>
                        )}
                      </>
                    }>
                    <ListItemButton sx={{ m: 0, p: 1, pl: 2 }}>
                      <ListItemText
                        sx={{ m: 0 }}
                        primary={item.title}
                        secondary={`Created on ${new Date(item.dateCreated).toLocaleDateString(
                          "en-US",
                          {
                            month: "2-digit",
                            day: "2-digit",
                            year: "numeric"
                          }
                        )}`}
                      />
                    </ListItemButton>
                  </ListItem>
                </Card>
              ))}
              <Stack spacing={1.5}>
                {errorMessage && (
                  <Alert severity="error" icon={<ErrorIcon />} sx={{ mt: 2 }}>
                    {errorMessage}
                  </Alert>
                )}
                <Divider />
                <Stack direction="row" sx={{ justifyContent: "space-between",  display: "flex" }} >
                  <Box>
                    <Button
                      sx={{ textTransform: "none" }}
                      variant="outlined"
                      onClick={() => {
                        if (resumes?.length === 5) setOpenResumeReachedModal(true);
                        else setOpenResumeBuilder(true);
                      }}>
                      {TEXT_GENERATE_RESUME}
                    </Button>
                  </Box>
                  {from !== "myJobsModal" ? (
                    <Button
                      sx={{ textTransform: "none" }}
                      loading={isSubmitting}
                      variant="contained"
                      onClick={submitResume}
                      disabled={isLoading || selectedResumeIndex === null}>
                      {TEXT_SUBMIT_APPLICATION}
                    </Button>
                  ) : null}
                </Stack>
              </Stack>
            </Stack>
          )}
        </Box>
      </Modal>
      {openResumeBuilder && (
        <ResumeBuilderModal
          open={openResumeBuilder}
          onClose={() => setOpenResumeBuilder(false)}
          fetchResumes={fetchResumes}
          setOpenResumeBuilder={setOpenResumeBuilder}
          setErrorMessage={setErrorMessage}
        />
      )}
      {openResumeDetailsModal && (
        <ResumeDetailsModal
          Open={openResumeDetailsModal}
          Close={handleCloseResumeDetail}
          resumeData={selectedResume?.resumePdf}
          title={selectedResume?.title}
          from="Resume-List"
        />
      )}
      {openResumeReachedModal && (
        <ResumeReachedLimitModal
          open={openResumeReachedModal}
          onClose={() => setOpenResumeReachedModal(false)}
          enableDeleteResumeButton={() => {
            setShowDeleteResumeButton(true);
            setOpenResumeReachedModal(false);
          }}
        />
      )}
      {openDeleteConfirmModal && (
        <DeleteConfirmation
          open={openDeleteConfirmModal}
          onClose={() => setOpenDeleteConfirmModal(false)}
          headerText={TEXT_CONFIRM_DELETE}
          secondaryText={TEXT_DELETE_THIS_RESUME}
          onBadgeClick={handleDelete}
          actionBtnText={TEXT_MENU_DELETE_BTN}
        />
      )}
    </>
  );
}

export default ResumeList;

